import script from "./LiabilityDateHandler.vue?vue&type=script&setup=true&lang=js"
export * from "./LiabilityDateHandler.vue?vue&type=script&setup=true&lang=js"

import "./LiabilityDateHandler.vue?vue&type=style&index=0&id=3a8eee8e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a8eee8e"]])

export default __exports__